/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */

/** @module core/modules/string-utils/inject-before */

/**
 * @description Adds zeros to the beginning of the string until specified length is reached.
 * @param {(string|number)} str - Input string.
 * @param {number} length - Desired length.
 * @param {string} [char=' '] - Character to be injected.
 * @returns {string} Resulting string.
 */
function injectBefore(str, length, char) {
  var count = length - (str = str.toString()).length;

  if (count <= 0) {
    return str;
  } else {
    while (count > 0) {
      str = (char || ' ') + str;
      count--;
    }
  }

  return str;
}

export { injectBefore };